// extracted by mini-css-extract-plugin
module.exports = {"root":"UserHistoryDrawerQuery-root-99e1fe014bfea35f5d568dd70086da5a"};